// extracted by mini-css-extract-plugin
module.exports = {"ClockWrapper":"TimeClock_ClockWrapper__2Rky_","Time":"TimeClock_Time__3uBXV","Date":"TimeClock_Date__2PWxG"};